import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import { HomeVersionA } from "@screens/Home/VersionA";
import { HomeVersionANoGLP } from "@screens/Home/VersionANoGLP";
import { HomeVersionBlackFriday } from "@screens/Home/VersionBlackFriday";
import { WellnessContest } from "@screens/Home/WellnessContest";

import { BUILD_VERSION, GOOGLE_ANALYTICS_ID } from "./config";
import { initGAWeb } from "./utils/ga-web";
import { VersionB } from "@screens/Home/VersionB";
import { VersionBPromo40 } from "@screens/Home/VersionBPromo40";
import { VersionC } from "@screens/Home/VersionC";
import { VersionD } from "@screens/Home/VersionD";

/**
 * Main App component
 *
 * Routes to different landing page versions based on BUILD_VERSION environment variable.
 *
 * Available versions:
 * - "A" (default): Standard version with GLP-1 focus
 * - "BLACK_FRIDAY": Special promotional version with $40 reward offer
 *
 * To change version, set BUILD_VERSION environment variable:
 * - BUILD_VERSION=A npm start
 * - BUILD_VERSION=BLACK_FRIDAY npm start
 */
function App() {
  useEffect(() => {
    if (GOOGLE_ANALYTICS_ID) {
      initGAWeb(GOOGLE_ANALYTICS_ID);
    }
  }, []);

  switch (BUILD_VERSION) {
    case "A":
      return <HomeVersionA />;
    case "A_NO_GLP":
      return <HomeVersionANoGLP />;
    case "BLACK_FRIDAY":
      return <HomeVersionBlackFriday />;
    case "WELLNESS_CONTEST":
      return <WellnessContest />;
    case "B":
      return (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<VersionB />} />
            <Route path="/promo40" element={<VersionBPromo40 />} />
          </Routes>
        </BrowserRouter>
      );
    case "C":
      return <VersionC />;
    case "D":
      return <VersionD />;
    case "BCD":
      return (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<VersionB />} />
            <Route path="/4f09da" element={<VersionC />} />
            <Route path="/f8e396" element={<VersionD />} />
          </Routes>
        </BrowserRouter>
      );
    default:
      return <HomeVersionA />;
  }
}

export default App;
